(() => {
  "use strict";

  const root = document.querySelector("[data-pfhb101]");

  if (!root || root.dataset.ready === "1") return;

  root.dataset.ready = "1";
  root.dataset.freeWheel = "v182";

  document.documentElement.classList.add("pfhb101-document");
  document.body.classList.add("pfhb101-page");

  /*
   * IMPORTANT:
   * Do not set other Shopify sections to aria-hidden/inert.
   * That was blocking footer links, footer collapsibles,
   * and all sections after the custom collection section.
   */

  const hero = root.querySelector("[data-pfhb-hero]");
  const heroImage = hero?.querySelector(".pfhb101__hero-image");
  const heroLink = root.querySelector("[data-pfhb-hero-link]");
  const stage = root.querySelector("[data-pfhb-stage]");
  const collection = root.querySelector("[data-pfhb-collection]");
  const product = root.querySelector("[data-pfhb-product]");
  const title = root.querySelector("[data-pfhb-title]");
  const price = root.querySelector("[data-pfhb-price]");
  const status = root.querySelector("[data-pfhb-status]");
  const prev = root.querySelector("[data-pfhb-prev]");
  const next = root.querySelector("[data-pfhb-next]");
  const views = [...root.querySelectorAll("[data-pfhb-view]")];
  const items = [...root.querySelectorAll("[data-pfhb-thumb]")];

  if (!hero || !heroImage || !items.length) return;

  document
    .querySelectorAll(".shopify-section-group-header-group")
    .forEach((section) => {
      section.classList.add("pfhb101-menu-host");
    });

  const localMenu = root.querySelector(
    ".pfhb101__menu:not([data-pf-menu-open])"
  );

  if (localMenu) {
    const backHref =
      localMenu.getAttribute("href") || "/#discover-forms";

    localMenu.setAttribute("aria-label", "Open menu");
    localMenu.setAttribute("aria-haspopup", "true");
    localMenu.setAttribute("aria-expanded", "false");
    localMenu.setAttribute("role", "button");
    localMenu.dataset.pfhbMenuOpen = "1";

    if (!root.querySelector(".pfhb101__back")) {
      const back = document.createElement("a");

      back.className = "pfhb101__back";
      back.href = backHref;
      back.setAttribute(
        "aria-label",
        "Back to shop by silhouette"
      );

      back.innerHTML =
        '<span class="pfhb101__back-mark" aria-hidden="true">←</span><span>Back</span>';

      localMenu.insertAdjacentElement("afterend", back);
    }

    const openActualMenu = (event) => {
      event?.preventDefault();

      const globalOpener = document.querySelector(
        ".pf-header [data-pf-menu-open]"
      );

      if (globalOpener) {
        globalOpener.click();
        localMenu.setAttribute("aria-expanded", "true");
      }
    };

    localMenu.addEventListener("click", openActualMenu);

    localMenu.addEventListener("keydown", (event) => {
      if (event.key === " ") {
        event.preventDefault();
        openActualMenu(event);
      }
    });

    const globalMenu = document.querySelector("[data-pf-menu]");

    if (
      globalMenu &&
      typeof MutationObserver !== "undefined"
    ) {
      new MutationObserver(() => {
        localMenu.setAttribute(
          "aria-expanded",
          globalMenu.classList.contains("is-open")
            ? "true"
            : "false"
        );
      }).observe(globalMenu, {
        attributes: true,
        attributeFilter: ["class", "aria-hidden"],
      });
    }
  }

  const reduced = matchMedia(
    "(prefers-reduced-motion: reduce)"
  );

  const cssHeroMode =
    root.dataset.silhouette === "tote-bags" ||
    root.dataset.silhouette === "crossbody-bags";

  const isMobile = () =>
    matchMedia("(max-width:749px)").matches;

  const mod = (n, m) => ((n % m) + m) % m;

  const clamp = (value, min, max) =>
    Math.min(max, Math.max(min, value));

  const visualStep = () =>
    isMobile()
      ? Math.min(88, innerWidth * 0.225)
      : Math.min(132, innerWidth * 0.072);

  const dragStep = () =>
    isMobile()
      ? clamp(innerWidth * 0.145, 50, 62)
      : clamp(innerWidth * 0.062, 78, 96);

  const initialIndex = (() => {
    const ring = root.querySelector("[data-pfhb-ring]");

    const fromRing = ring
      ? Number(ring.dataset.pfhbInitialIndex)
      : NaN;

    if (
      Number.isFinite(fromRing) &&
      fromRing >= 0 &&
      fromRing < items.length
    ) {
      return fromRing;
    }

    const marked = items.findIndex((el) =>
      el.classList.contains("is-active")
    );

    return marked >= 0 ? marked : 0;
  })();

  let active = initialIndex;
  let rendered = initialIndex;
  let position = initialIndex;
  let transitionToken = 0;
  let drag = null;
  let blockUntil = 0;

  let settleFrame = 0;
  let wheelTimer = 0;
  let wheelVelocity = 0;
  let wheelLastTime = 0;
  let layoutFrame = 0;

  const loaded = new Map();

  const responsiveSource = (src) => {
    if (!src || cssHeroMode) return src;

    const fraction =
      root.dataset.silhouette === "top-handle-bags"
        ? isMobile()
          ? 0.72
          : innerWidth <= 1100
          ? 0.44
          : 0.32
        : isMobile()
        ? 0.58
        : innerWidth <= 1100
        ? 0.4
        : 0.3;

    const target =
      innerWidth *
      fraction *
      Math.min(devicePixelRatio || 1, 2);

    const width =
      [300, 400, 500, 600, 750, 900, 1100].find(
        (w) => w >= target
      ) || 1100;

    return src.replace(
      /([?&])width=\d+/,
      "$1width=" + width
    );
  };

  const datum = (index) => {
    const el = items[mod(index, items.length)];

    return {
      el: el,
      index: mod(index, items.length),
      image: responsiveSource(el.dataset.image),
      title: el.dataset.title,
      price: el.dataset.price,
      url: el.dataset.url,
      tone: el.dataset.tone || "150,120,90",
      scale: el.dataset.scale || "1",
    };
  };

  const shortest = (value) => {
    let delta = mod(value, items.length);

    if (delta > items.length / 2) {
      delta -= items.length;
    }

    return delta;
  };

  const nearestPosition = (index, around = position) =>
    index +
    Math.round((around - index) / items.length) *
      items.length;

  function preload(src) {
    if (!src) return Promise.resolve();

    if (loaded.has(src)) {
      return loaded.get(src);
    }

    const promise = new Promise((resolve) => {
      const image = new Image();
      let settled = false;

      const done = () => {
        if (!settled) {
          settled = true;
          resolve();
        }
      };

      image.onload = done;
      image.onerror = done;
      image.src = src;

      if (image.complete) {
        done();
      }
    });

    loaded.set(src, promise);

    return promise;
  }

  function layoutNow() {
    layoutFrame = 0;

    const mobile = isMobile();
    const step = visualStep();
    const limit = mobile ? 3.05 : 5.05;

    const visualCenter = mod(
      Math.round(position),
      items.length
    );

    const freeMoving =
      root.dataset.wheelState === "dragging" ||
      root.dataset.wheelState === "free" ||
      root.dataset.wheelState === "momentum";

    const highlighted = freeMoving
      ? visualCenter
      : active;

    items.forEach((item, index) => {
      const slot = shortest(index - position);
      const distance = Math.abs(slot);

      const x = slot * step;

      const y =
        distance * (mobile ? 7 : 5) +
        distance *
          distance *
          (mobile ? 2 : 1.3) -
        (distance < 0.25
          ? mobile
            ? 5
            : 6
          : 0);

      const scale = Math.max(
        mobile ? 0.72 : 0.69,
        index === visualCenter
          ? 1.08
          : 1 - distance * (mobile ? 0.07 : 0.045)
      );

      const opacity =
        distance > limit
          ? 0
          : Math.max(
              0.16,
              1 - distance * (mobile ? 0.15 : 0.075)
            );

      item.style.setProperty(
        "--x",
        `${x.toFixed(2)}px`
      );

      item.style.setProperty(
        "--y",
        `${y.toFixed(2)}px`
      );

      item.style.setProperty(
        "--s",
        scale.toFixed(4)
      );

      item.style.setProperty(
        "--o",
        opacity.toFixed(4)
      );

      item.style.zIndex = String(
        100 - Math.round(distance * 9)
      );

      item.classList.toggle(
        "is-visible",
        opacity > 0.05
      );

      item.classList.toggle(
        "is-active",
        index === highlighted
      );

      item.tabIndex = index === active ? 0 : -1;

      if (index === active) {
        item.setAttribute("aria-current", "true");
      } else {
        item.removeAttribute("aria-current");
      }
    });

    if (collection) {
      collection.dataset.wheelPosition =
        position.toFixed(3);
    }
  }

  function layout() {
    if (layoutFrame) return;

    layoutFrame = requestAnimationFrame(layoutNow);
  }

  function layoutImmediate() {
    if (layoutFrame) {
      cancelAnimationFrame(layoutFrame);
      layoutFrame = 0;
    }

    layoutNow();
  }

  function updateContent(data, animate) {
    if (heroLink) {
      heroLink.href = data.url;
      heroLink.setAttribute(
        "aria-label",
        `View ${data.title}`
      );
    }

    views.forEach((link) => {
      link.href = data.url;
      link.setAttribute(
        "aria-label",
        `View ${data.title}`
      );
    });

    if (title) {
      title.textContent = data.title;
    }

    if (price) {
      price.textContent = data.price;
    }

    if (status) {
      status.textContent = data.title;
    }

    root.style.setProperty(
      "--pfhb-tone",
      data.tone
    );

    if (
      product &&
      animate &&
      !reduced.matches &&
      typeof product.animate === "function"
    ) {
      if (
        typeof product.getAnimations === "function"
      ) {
        product
          .getAnimations()
          .forEach((animation) => animation.cancel());
      }

      product.animate(
        [
          { opacity: 0.52 },
          { opacity: 1 },
        ],
        {
          duration: 220,
          easing: "ease-out",
        }
      );
    }
  }

  function cancelHeroMotion() {
    if (
      typeof heroImage.getAnimations === "function"
    ) {
      heroImage
        .getAnimations()
        .forEach((animation) => animation.cancel());
    }

    if (
      product &&
      typeof product.getAnimations === "function"
    ) {
      product
        .getAnimations()
        .forEach((animation) => animation.cancel());
    }
  }

  async function changeHero(index) {
    index = mod(index, items.length);

    if (
      index === active &&
      index === rendered
    ) {
      layout();
      return;
    }

    const data = datum(index);
    const token = ++transitionToken;

    active = index;
    layout();
    cancelHeroMotion();

    root.dataset.transitioning = "1";
    root.style.setProperty(
      "--pfhb-tone",
      data.tone
    );

    if (index === rendered) {
      updateContent(data, false);
      root.dataset.transitioning = "0";
      return;
    }

    if (cssHeroMode) {
      updateContent(data, true);
      rendered = index;
      root.dataset.transitioning = "0";
      return;
    }

    await preload(data.image);

    if (token !== transitionToken) return;

    if (
      reduced.matches ||
      typeof heroImage.animate !== "function"
    ) {
      heroImage.removeAttribute("srcset");
      heroImage.removeAttribute("sizes");
      heroImage.src = data.image;
      heroImage.alt = data.title;

      heroImage.style.setProperty(
        "--piece-scale",
        data.scale
      );

      updateContent(data, false);
      rendered = index;
      root.dataset.transitioning = "0";

      return;
    }

    const currentScale =
      Number(datum(rendered).scale) || 1;

    const out = heroImage.animate(
      [
        {
          opacity: 1,
          transform: `translateX(-50%) scale(${currentScale})`,
        },
        {
          opacity: 0,
          transform: `translateX(-50%) scale(${currentScale * 0.985})`,
        },
      ],
      {
        duration: 90,
        easing: "ease-in",
        fill: "forwards",
      }
    );

    try {
      await out.finished;
    } catch (_) {
      return;
    }

    if (token !== transitionToken) {
      out.cancel();
      return;
    }

    out.cancel();

    heroImage.removeAttribute("srcset");
    heroImage.removeAttribute("sizes");
    heroImage.src = data.image;
    heroImage.alt = data.title;

    heroImage.style.setProperty(
      "--piece-scale",
      data.scale
    );

    updateContent(data, true);
    rendered = index;

    const nextScale = Number(data.scale) || 1;

    const incoming = heroImage.animate(
      [
        {
          opacity: 0,
          transform: `translateX(-50%) scale(${nextScale * 0.985})`,
        },
        {
          opacity: 1,
          transform: `translateX(-50%) scale(${nextScale})`,
        },
      ],
      {
        duration: 210,
        easing: "cubic-bezier(.2,.7,.2,1)",
        fill: "both",
      }
    );

    try {
      await incoming.finished;
    } catch (_) {
      return;
    }

    if (token === transitionToken) {
      incoming.cancel();
      root.dataset.transitioning = "0";
    }
  }

  function stopSettle() {
    if (settleFrame) {
      cancelAnimationFrame(settleFrame);
      settleFrame = 0;
    }
  }

  function animateTo(target, initialVelocity = 0) {
    stopSettle();

    if (
      reduced.matches ||
      Math.abs(target - position) < 0.002
    ) {
      position = target;
      layoutImmediate();
      root.dataset.wheelState = "idle";
      return;
    }

    let velocity = clamp(
      initialVelocity,
      -12,
      12
    );

    let last = performance.now();
    let elapsed = 0;

    root.dataset.wheelState = "settling";

    const stiffness = 118;
    const damping = 22;

    const tick = (now) => {
      const dt = clamp(
        (now - last) / 1000,
        0.001,
        0.028
      );

      last = now;
      elapsed += dt;

      const acceleration =
        (target - position) * stiffness -
        velocity * damping;

      velocity += acceleration * dt;
      position += velocity * dt;

      layout();

      if (
        (Math.abs(target - position) < 0.005 &&
          Math.abs(velocity) < 0.065) ||
        elapsed > 0.72
      ) {
        position = target;
        layoutImmediate();
        settleFrame = 0;
        root.dataset.wheelState = "idle";
      } else {
        settleFrame = requestAnimationFrame(tick);
      }
    };

    settleFrame = requestAnimationFrame(tick);
  }

  function settleTo(rawTarget, initialVelocity = 0) {
    const target = Math.round(rawTarget);
    const index = mod(target, items.length);

    changeHero(index);
    animateTo(target, initialVelocity);
  }

  function move(direction) {
    const base = nearestPosition(
      active,
      position
    );

    settleTo(
      base + (direction > 0 ? 1 : -1)
    );
  }

  items.forEach((item, index) => {
    item.addEventListener("click", (event) => {
      event.preventDefault();

      if (performance.now() < blockUntil) return;

      const target = nearestPosition(
        index,
        position
      );

      const atRest =
        Math.abs(
          position -
            nearestPosition(active, position)
        ) < 0.01;

      if (
        index === active &&
        index === rendered &&
        atRest &&
        root.dataset.transitioning !== "1"
      ) {
        location.assign(item.dataset.url);
        return;
      }

      settleTo(target, 0);
    });
  });

  prev?.addEventListener("click", (event) => {
    event.preventDefault();
    move(-1);
  });

  next?.addEventListener("click", (event) => {
    event.preventDefault();
    move(1);
  });

  heroLink?.addEventListener("click", (event) => {
    if (performance.now() < blockUntil) {
      event.preventDefault();
    }
  });

  function pointerDown(event) {
    if (drag) return;

    if (
      event.pointerType === "mouse" &&
      event.button !== 0
    ) {
      return;
    }

    if (
      event.target instanceof Element &&
      event.target.closest(
        "[data-pfhb-prev],[data-pfhb-next]"
      )
    ) {
      return;
    }

    stopSettle();

    if (wheelTimer) {
      clearTimeout(wheelTimer);
      wheelTimer = 0;
    }

    const source =
      event.currentTarget === stage
        ? "stage"
        : "collection";

    const now = performance.now();

    drag = {
      id: event.pointerId,
      source: source,
      startX: event.clientX,
      startY: event.clientY,
      lastX: event.clientX,
      lastY: event.clientY,
      lastTime: now,
      velocityItems: 0,
      moved: false,
      totalX: 0,
    };

    root.dataset.wheelState = "dragging";

    if (source === "collection") {
      collection?.classList.add("is-dragging");
    }

    try {
      event.currentTarget.setPointerCapture(
        event.pointerId
      );
    } catch (_) {}
  }

  function pointerMove(event) {
    if (
      !drag ||
      event.pointerId !== drag.id
    ) {
      return;
    }

    const totalX =
      event.clientX - drag.startX;

    const totalY =
      event.clientY - drag.startY;

    if (!drag.moved) {
      if (Math.abs(totalX) < 2.5) return;

      if (
        drag.source === "stage" &&
        Math.abs(totalY) > Math.abs(totalX) * 1.35
      ) {
        drag = null;
        root.dataset.wheelState = "idle";
        return;
      }

      drag.moved = true;
    }

    if (event.cancelable) {
      event.preventDefault();
    }

    const now = performance.now();

    const dt = Math.max(
      4,
      now - drag.lastTime
    );

    const dx =
      event.clientX - drag.lastX;

    const deltaItems =
      -dx / dragStep();

    const instantItemsPerSecond =
      deltaItems / (dt / 1000);

    drag.velocityItems =
      drag.velocityItems * 0.64 +
      instantItemsPerSecond * 0.36;

    drag.lastX = event.clientX;
    drag.lastY = event.clientY;
    drag.lastTime = now;
    drag.totalX = totalX;

    position += deltaItems;

    layout();
  }

  function finishPointer(
    event,
    cancelled = false
  ) {
    if (
      !drag ||
      (event?.pointerId != null &&
        event.pointerId !== drag.id)
    ) {
      return;
    }

    const released = drag;

    drag = null;

    collection?.classList.remove("is-dragging");

    if (!released.moved) {
      root.dataset.wheelState = "idle";
      layout();
      return;
    }

    blockUntil = performance.now() + 300;

    if (event?.cancelable) {
      event.preventDefault();
    }

    const velocity = cancelled
      ? 0
      : clamp(
          released.velocityItems,
          -14,
          14
        );

    const projection = cancelled
      ? 0
      : clamp(
          velocity * 0.18,
          -4.5,
          4.5
        );

    root.dataset.wheelState = "momentum";

    settleTo(
      position + projection,
      velocity
    );
  }

  [stage, collection]
    .filter(Boolean)
    .forEach((node) => {
      node.addEventListener(
        "pointerdown",
        pointerDown,
        { capture: true }
      );

      node.addEventListener(
        "dragstart",
        (event) => event.preventDefault()
      );
    });

  window.addEventListener(
    "pointermove",
    pointerMove,
    {
      capture: true,
      passive: false,
    }
  );

  window.addEventListener(
    "pointerup",
    (event) => finishPointer(event, false),
    { capture: true }
  );

  window.addEventListener(
    "pointercancel",
    (event) => finishPointer(event, true),
    { capture: true }
  );

  window.addEventListener("blur", () => {
    if (drag) {
      finishPointer(null, true);
    }
  });

  root.addEventListener("keydown", (event) => {
    if (event.key === "ArrowRight") {
      event.preventDefault();
      move(1);
    } else if (event.key === "ArrowLeft") {
      event.preventDefault();
      move(-1);
    }
  });

  collection?.addEventListener(
    "wheel",
    (event) => {
      if (isMobile()) return;

      const delta =
        Math.abs(event.deltaX) >
        Math.abs(event.deltaY)
          ? event.deltaX
          : event.deltaY;

      if (Math.abs(delta) < 0.25) return;

      event.preventDefault();
      stopSettle();

      root.dataset.wheelState = "free";

      const now = performance.now();

      const dt = wheelLastTime
        ? Math.max(8, now - wheelLastTime)
        : 16;

      wheelLastTime = now;

      const normalized =
        clamp(delta, -220, 220) /
        (dragStep() * 0.82);

      position += normalized;

      wheelVelocity =
        wheelVelocity * 0.56 +
        (normalized / (dt / 1000)) * 0.44;

      layout();

      if (wheelTimer) {
        clearTimeout(wheelTimer);
      }

      wheelTimer = setTimeout(() => {
        wheelTimer = 0;

        const velocity = clamp(
          wheelVelocity,
          -11,
          11
        );

        const projected =
          position +
          clamp(
            velocity * 0.12,
            -3.2,
            3.2
          );

        settleTo(projected, velocity);

        wheelVelocity = 0;
        wheelLastTime = 0;
      }, 96);
    },
    { passive: false }
  );

  addEventListener(
    "resize",
    () => {
      position = nearestPosition(
        active,
        position
      );

      layoutImmediate();
    },
    { passive: true }
  );

  const first = datum(initialIndex);

  updateContent(first, false);

  heroImage.style.setProperty(
    "--piece-scale",
    first.scale
  );

  root.dataset.wheelState = "idle";

  layoutImmediate();

  const warmIndex = (index) => {
    if (cssHeroMode) return;

    const item = items[mod(index, items.length)];

    if (item) {
      preload(
        responsiveSource(item.dataset.image)
      );
    }
  };

  items.forEach((item, index) => {
    item.addEventListener(
      "pointerenter",
      () => warmIndex(index),
      { passive: true }
    );

    item.addEventListener(
      "focus",
      () => warmIndex(index),
      { passive: true }
    );
  });

  prev?.addEventListener(
    "pointerenter",
    () => warmIndex(active - 1),
    { passive: true }
  );

  next?.addEventListener(
    "pointerenter",
    () => warmIndex(active + 1),
    { passive: true }
  );

  [stage, collection]
    .filter(Boolean)
    .forEach((node) => {
      node.addEventListener(
        "pointerdown",
        () => {
          warmIndex(active - 1);
          warmIndex(active + 1);
        },
        { passive: true }
      );
    });
})();

(() => {
  "use strict";

  const root = document.querySelector(
    '.pfhb101.pfhb101--silhouette[data-silhouette="work-tote-bags"]'
  );

  if (!root) return;

  const stage = root.querySelector(
    ".pfhb101__stage"
  );

  const hero = root.querySelector(
    ".pfhb101__hero-image"
  );

  const contact = root.querySelector(
    ".pfhb101__contact"
  );

  const aura = root.querySelector(
    ".pfhb101__aura"
  );

  const set = (el, prop, value) => {
    if (el) {
      el.style.setProperty(
        prop,
        value,
        "important"
      );
    }
  };

  function apply() {
    const w = window.innerWidth;
    const h = window.innerHeight;

    root.dataset.worktoteForce = "v162";

    set(stage, "top", "auto");

    if (w <= 749) {
      set(
        stage,
        "bottom",
        h <= 720 ? "45.5svh" : "46.5svh"
      );

      set(hero, "bottom", "0%");
      set(contact, "bottom", "-0.6%");
      set(aura, "bottom", "0.5%");
    } else if (w <= 1100) {
      set(stage, "bottom", "43.5svh");
      set(hero, "bottom", "3.5%");
      set(contact, "bottom", "2.8%");
      set(aura, "bottom", "3.8%");
    } else {
      set(stage, "bottom", "43.5svh");
      set(hero, "bottom", "5.5%");
      set(contact, "bottom", "4.8%");
      set(aura, "bottom", "5.8%");
    }
  }

  apply();
  requestAnimationFrame(apply);
  setTimeout(apply, 120);

  window.addEventListener(
    "resize",
    apply,
    { passive: true }
  );
})();

document
  .querySelectorAll("[data-pfhb-copy-wrap]")
  .forEach((wrap) => {
    const copy = wrap.querySelector(
      "[data-pfhb-copy]"
    );

    const toggle = wrap.querySelector(
      "[data-pfhb-copy-toggle]"
    );

    if (!copy || !toggle) return;

    if (
      copy.scrollHeight >
      copy.clientHeight + 1
    ) {
      wrap.classList.add("has-overflow");
    }

    toggle.addEventListener("click", (e) => {
      e.preventDefault();

      document
        .getElementById("pfhb-full-description")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    });
  });